import { type NuxtAxiosInstance } from "@nuxtjs/axios";

import { useApi } from "@/utils/api";

export default function useConsumerSearchApi($axios: NuxtAxiosInstance) {
  const baseUrl = "/v1/search";
  const _api = useApi({ name: "consumerSearchService", url: baseUrl, $axios });

  async function fetchLtkSearchResults(data: Omit<PostConsumerSearchRequest, "types">) {
    return await _api.request<PostConsumerSearchPostResponse>({
      method: "POST",
      data: {
        ...data,
        types: ["post", "product"],
      },
    });
  }

  async function fetchLtkIDSearchResults(data: Omit<PostConsumerSearchRequest, "types">) {
    return await _api.request<PostConsumerSearchPostIDResponse>({
      url: `${baseUrl}/ids`,
      method: "POST",
      data: {
        ...data,
        types: ["post", "product"],
      },
    });
  }

  async function fetchProfileSearchResults(data: Omit<PostConsumerSearchRequest, "types">) {
    return await _api.request<PostConsumerSearchProfileResponse>({
      method: "POST",
      data: {
        ...data,
        types: ["profile"],
      },
    });
  }

  async function fetchProfileIDSearchResults(data: Omit<PostConsumerSearchRequest, "types">) {
    return await _api.request<PostConsumerSearchProfileIDResponse>({
      url: `${baseUrl}/ids`,
      method: "POST",
      data: {
        ...data,
        types: ["profile", "post", "product"],
        childrenCount: 0,
      },
    });
  }

  async function fetchBrandSearchResults(data: PostConsumerSearchBrandRequest) {
    return await _api.request<PostConsumerSearchBrandsResponse>({
      url: `${baseUrl}/brand-profile`,
      method: "POST",
      data,
    });
  }

  return {
    fetchLtkSearchResults,
    fetchLtkIDSearchResults,
    fetchProfileSearchResults,
    fetchProfileIDSearchResults,
    fetchBrandSearchResults,
  };
}
